







































































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import UUIFComponents from '@/shared/uuifComponent';
import { TableColumnConfig, TableEntry, ColumnsAdjustRequestData, SortedColumnInfo, ColumnSortRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { DropMenuItem, SwDropMenu } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import { CreateElement, VNode } from 'vue';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import ChangeBillingAddress from './../../shared/changeBillingAddress/changeBillingAddress.component.vue';
import ConfirmDeletedDialog from './../../shared/confirmDeleteDialog/confirmDeleteDialog.vue';
import { MswAppTitle }  from '@/shared/msw-app-title';
import { PageTitleConfig } from '../../shared/msw-app-title/type';
const cssPrefix = 'autoRenewals';
@Component({
  components:{
    ...UUIFComponents,
    SwExpandableTextfield,
    SwTextfield,
    SwDropMenu,
    SwIcon,
    ChangeBillingAddress,
    ConfirmDeletedDialog,
    MswAppTitle,
  },
})
export default class SandboxAutoRenewals extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  menuOpened: boolean = false;
  selectedMultiItem: any = {};
  deleteRenewalData: any = {};
  searchInputText: string = '';
  isExpandSearchFilter: boolean = false;
  adjustedColumns: ColumnsAdjustRequestData = {};
  filterColumnKey: string = '';
  filterColumnValue: string = '';
  selectedColumnFilters: any[] = [];
  sortedColumns: SortedColumnInfo[] = [];

  rowData: any[] = [];
  searchInputChips: any[] = [];
  partialData: any[] = [];

  // filter
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };
  globalSearchConfig: any = {
    isGlobalSearch: false,
    globalSearchKey: '',
  };
  showAutoRenewalTable: boolean = true;
  isLoadingData: boolean = true;
  showDeleteModal: boolean = false;

  addressID: string = '';
  autorenewalID: string = '';

  pageTitleConfig: PageTitleConfig = {
    pageTitle: 'Manage Auto Renewal',
    pageParentName: 'Orders Management',
    isShowBackButton: false,
  };
  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
    // this.selectedColumnsConfig.forEach((col) => {
    //   const adjustInfo = data[col.key];
    //   if (!adjustInfo) { return; }
    //   Vue.set(col, 'width', adjustInfo);
    // });
  }

  get menuItems(): DropMenuItem[] {
    return [
      { id: 'serialNumber', content: `${this.$t('autoRenewals.serialNumber')}` },
      { id: 'friendlyName', content: `${this.$t('autoRenewals.friendlyName')}` },
      { id: 'ssipn', content: `${this.$t('autoRenewals.partNumber')}` },
      { id: 'description', content: `${this.$t('autoRenewals.description')}` },
      { id: 'autoRenewalDate', content: `${this.$t('autoRenewals.autoRenewalDate')}` },
    ];
  }
  get getAddressID() {
    return this.addressID;
  }
  get getAutorenewalID() {
    return this.autorenewalID;
  }
  get tableHeight() {
    return 'calc(100vh - 320px)';
  }
  get returnData() : TableEntry[] {
    const  tableData: TableEntry[] = this.partialData.length > 0 ? [...this.partialData] : [];
    return tableData.sort((ele1: any, ele2: any) => {
      const date1 = new Date(ele1.autoRenewalDate);
      const date2 = new Date(ele2.autoRenewalDate);
      return date1 > date2 ? 1 : -1;
    });
  }
  get selectedColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: `${this.$t('autoRenewals.serialNumber')}`,
        width: 200,
        sorter: true,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.serialNumber;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                <div style="color: #47afe8;" onClick={ () => { this.onNavigateToProduct(data.entry.serialNumber.toString()); } }>
                  { data.entry.serialNumber }
                </div>
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.serialNumber && (
                    <SwIcon
                      name="filter"
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: this.$t('common.addFilter'), compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.globalSearchConfig.globalSearchKey = data.entry.serialNumber;
                        this.filterByEachRow('serialNumber');
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'friendlyName',
        dataKey: 'friendlyName',
        title: `${this.$t('autoRenewals.friendlyName')}`,
        width: 250,
        scalable:true,
        sorter: true,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.friendlyName;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                { data.entry.friendlyName }

                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.friendlyName && (
                    <SwIcon
                      name="filter"
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: this.$t('common.addFilter'), compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.globalSearchConfig.globalSearchKey = data.entry.friendlyName;
                        this.filterByEachRow('friendlyName');
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'partNo',
        dataKey: 'ssipn',
        title: `${this.$t('autoRenewals.partNumber')}`,
        width: 120,
        sorter: true,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.ssipn;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                { data.entry.ssipn }

                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.ssipn && (
                    <SwIcon
                      name="filter"
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: this.$t('common.addFilter'), compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.globalSearchConfig.globalSearchKey = data.entry.ssipn;
                        this.filterByEachRow('ssipn');
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'description',
        dataKey: 'description',
        title: `${this.$t('autoRenewals.description')}`,
        width: 300,
        scalable:true,
        sorter: true,
        render: (createElement: CreateElement, data: { entry: TableEntry }) => {
          return createElement('div', { domProps: { innerHTML: data.entry.description } });
        },
      },
      {
        key: 'paymentDetails',
        dataKey: 'paymentDetails',
        title: `${this.$t('autoRenewals.paymentDetails')}`,
        width:  200,
        scalable:true,
        sorter: true,
        render: (createElement:CreateElement, data:{ entry :TableEntry }) : VNode  => this.paymentDetails(createElement, data), // tslint:disable-line
      },
      {
        key: 'autoRenewalDate',
        dataKey: 'autoRenewalDate',
        title: `${this.$t('autoRenewals.autoRenewalDate')}`,
        width:  200,
        sorter: true,
        // tslint:disable
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.autoRenewalDate;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                { data.entry.autoRenewalDate }

                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.autoRenewalDate && (
                    <SwIcon
                      name="filter"
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: this.$t('common.addFilter'), compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.globalSearchConfig.globalSearchKey = data.entry.autoRenewalDate;
                        this.filterByEachRow('autoRenewalDate');
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'priority',
        dataKey: 'priority',
        title: `${this.$t('common.action')}`,
        width: 120,
        scalable:true,
        render: (h: CreateElement, data: { entry: TableEntry }) : VNode => { // tslint:disable-line
          return (
            <div>
                <SwIcon  props-size={14} name="trash" color="#333"
                nativeOn-click={() => {
                  this.onDelete(data);
                }
              }></SwIcon>
            </div>
          ) as VNode;
        },
      }
  ]}

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }


  paymentDetails(h: CreateElement, data: { entry: TableEntry }) { // tslint:disable-line
    return (
      <div>
        { data.entry.cardNumber ?
        <span>
          {  data.entry.isReadOnlyAccess ?
          <span>
            {  `${data.entry.cardType}:xxx-${data.entry.cardNumber}` }
          </span> :
          <span style="color: #47afe8;" onClick={() => { this.editBillingInfo(data.entry.customerAddressId, data.entry.autoRenewalID); } }>
            {  `${data.entry.cardType}:xxx-${data.entry.cardNumber}` }
          </span>
          }
        </span> :
        <span>
          { data.entry.bankAccNumber ?
            <span>
              { data.entry.isReadOnlyAccess ?
                <span>
                  { `${data.entry.bankName}-${data.entry.bankAccNumber}` }
                </span> :
                <span  style="color: #47afe8;"  onClick={ () => { this.editBillingInfo(data.entry.customerAddressId, data.entry.autoRenewalID); } }>
                  { `${data.entry.bankName}-${data.entry.bankAccNumber}` }
                </span>
              }
            </span> :
            <span>
            </span>
          }
        </span>
        }
      </div>
    ) as VNode;
  }
  onNavigateToProduct(serialNumber: any) {
    this.$router.push({ path:'/m/feature/products', query:{ serialNumber, tab:'productdetails' } });
  }
  created() {
    this.setHelpContentId({ helpId: ['renewal-manager'] });
    this.getAutoRenewals();
  }
  onSelectMultiItem(option: any) {
    this.menuOpened = !this.menuOpened;
    const ftrObj = this.menuItems.filter((item) => {
      return item.id === option &&
      this.selectedColumnFilters.findIndex(item => item.id === option) === -1; // Ignoring duplicate column filter
    })[0];
    if (ftrObj) {
      this.selectedColumnFilters.push(ftrObj);
      this.filterSearchConfig.isEnableFilterSearch = true;
      this.filterSearchConfig.filterSearchOption = option;
      this.filterSearchConfig.filterSearchLabel = this.menuItems.filter(ele => ele.id.toString() === option)[0].content;
    }
  }
  getAutoRenewals() {
    this.isLoadingData = true;
    this.$store.dispatch('SandboxAutoRenewalStoreModule/getAutoRenewals')
      .then((res: any) => {
        if (res.hasOwnProperty('operationStatus') &&
           res.operationStatus === 'OK' &&
           res.hasOwnProperty('content') &&
           res.content.hasOwnProperty('autoRenewalList')) {
          // tslint:disable-next-line
          this.$store.commit('SandboxAutoRenewalStoreModule/setAutoRenewalList', res.content.autoRenewalList ? res.content.autoRenewalList: []);
          this.rowData = [];
          this.partialData = [];
          // tslint:disable-next-line
          this.rowData = this.$store.getters['SandboxAutoRenewalStoreModule/getAutoRenewalList'] ? this.$store.getters['SandboxAutoRenewalStoreModule/getAutoRenewalList'] : [];
          this.partialData = this.rowData.length > 0 ? this.rowData : [];
        }
        this.isLoadingData = false;
        this.$store.commit('stopLoading');
      })
      .catch((errResponse) => {
        console.error(errResponse);
        this.isLoadingData = false;
        this.$store.commit('stopLoading');
      });
  }
  editBillingInfo(customerAddressId: any, autoRenewalID: any) {
    this.showAutoRenewalTable = false;
    if (this.showAutoRenewalTable) {
      this.pageTitleConfig = {
        pageTitle: 'Change Billing Address',
        pageParentName: 'Orders Management',
        isShowBackButton: true,
      };
    }
    this.addressID = customerAddressId;
    this.autorenewalID = autoRenewalID;
  }
  onClickMultiMenuButton() {
    this.menuOpened = !this.menuOpened;
  }
  filterByEachRow(type: any) {
    if (this.globalSearchConfig.globalSearchKey) {
      if (!this.searchInputChips.includes(this.globalSearchConfig.globalSearchKey)) {
        this.searchInputChips.push(this.globalSearchConfig.globalSearchKey.trim());
      }
      this.applyAllFilters(type);
      this.globalSearchConfig.isGlobalSearch = true;
    }
  }
  handleSearchFilter() {
    if (this.globalSearchConfig.globalSearchKey !== '') {
      this.searchInputChips.push(this.globalSearchConfig.globalSearchKey.trim());
      this.applyAllFilters();
      this.globalSearchConfig.isGlobalSearch = true;
    }
    this.isExpandSearchFilter = !this.isExpandSearchFilter;
  }
  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }
  onDelete(data: { entry: TableEntry }) {
    this.deleteRenewalData = {
      componentName: 'autorenewal',
      autoRenewalID: data.entry.autoRenewalID ? data.entry.autoRenewalID : '',
    };
    this.showDeleteModal = true;
  }
  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push(this.filterSearchConfig.filterSearchKey.trim());
      this.applyAllFilters(this.filterSearchConfig.filterSearchOption);
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }
  applyAllFilters(option : any = 'all') {
    const data: any[] = [...this.rowData];
    const filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.searchInputChips.length === 0) {
      this.partialData = [...data];
      this.$store.commit('stopLoading');
      return;
    }
    if (option === 'all') {
      this.searchInputChips.forEach((searchKey: string) => {
        filteredData.push(...data.filter((element: any) => {
          return (element.serialNumber.indexOf(searchKey) > -1 ||
                 element.description.indexOf(searchKey) > -1 ||
                 element.ssipn.indexOf(searchKey) > -1 ||
                 element.cardType.indexOf(searchKey) > -1 ||
                 element.cardNumber.indexOf(searchKey) > -1 ||
                 element.bankName.indexOf(searchKey) > -1 ||
                 element.bankAccNumber.indexOf(searchKey) > -1 ||
                 element.friendlyName.indexOf(searchKey) > -1 ||
                 element.autoRenewalDate.indexOf(searchKey) > -1);
        }));
      });
    } else {
      this.searchInputChips.forEach((searchKey: string) => {
        filteredData.push(...data.filter((element: any) => {
          return element[option].indexOf(searchKey) > -1;
        }));
      });
    }
    this.partialData = [...filteredData];
    this.$store.commit('stopLoading');
  }
  onGoBack() {
    this.showAutoRenewalTable = true;
    if (this.showAutoRenewalTable) {
      this.pageTitleConfig = {
        pageTitle: 'Manage Auto Renewals',
        pageParentName: 'Orders Management',
        isShowBackButton: false,
      };
    }
  }
  onRefreshPage() {
    this.getAutoRenewals();
    this.onRemoveAllFilters();
  }
  onRemoveAllFilters() {
    this.selectedColumnFilters = [];
    this.globalSearchConfig = {
      isGlobalSearch: false,
      globalSearchKey: '',
    };
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }
  get getDeleteRenewalData() {
    return this.deleteRenewalData;
  }
  onCloseDelete(result: any) {
    if (result && result.hasOwnProperty('status') && result.status === 'DELETE_SUCCESSFUL') {
      this.getAutoRenewals();
      this.onRemoveAllFilters();
    }
    this.showDeleteModal = false;
  }
  onEditAddress(value: string) {
    if (value === 'sucess') {
      this.getAutoRenewals();
      this.onRemoveAllFilters();
    }
    this.showAutoRenewalTable = true;
    if (this.showAutoRenewalTable) {
      this.pageTitleConfig = {
        pageTitle: 'Manage Auto Renewals',
        pageParentName: 'Orders Management',
        isShowBackButton: false,
      };
    }
  }
  onCloseBillingAddress() {
    this.showAutoRenewalTable = true;
  }
}
